import requestHandler from 'shared/utils/request-handler';
import { IResponseBalance } from './social.dto';

const BASE_URL = '/api/v1/SocialFollower';

export const POSTClaimSocialFollower = async (id: number) => {
	return requestHandler.call<IResponseBalance>({ url: `${BASE_URL}/claim?socialId=${id}`, method: 'post' }).then(res => res.data);
};
